<template>
  <div>
    <div>
      <el-switch
        style="margin-left: 20px"
        v-model="value1"
        @change="open(value1)"
        active-text="开"
        inactive-text="Co2发生器"
      >
      </el-switch>
    </div>

    <iframe
      src="http://120.26.202.178:10035/CFCM/#/cucumber/index"
      style="width: 100%; height: 500px"
      frameborder="0"
      scrolling="auto"
    >
    </iframe>
  </div>
</template>
<script>
import { searchUrl, changeControl } from '@/api/equipControl.js'
import { getDeviceInfoByLand } from '@/api/equip.js'
export default {
  name: 'MonitorOfDoctor',
  props: ['landId'],
  data() {
    return {
      value1: false,
      state: undefined,
      index: undefined,
    }
  },
  mounted() {
    //获取地块博士草莓园地块设备编号
    getDeviceInfoByLand(this.landId).then((resp) => {
      let obj = resp.data.find((item) => item.model == 'monitor')
      this.sn = obj ? obj.sn : undefined
    })
  },

  methods: {
    open(value1) {
      //当设备打开时，index=3表示控制第四路，index=2表示控制第三路，state=0代表关闭，state=1表示开启
      if (this.value1 == true) {
        this.state = 1
        this.index = 0
      } else {
        this.state = 0
        this.index = 0
      }

      //获取控制地块设备地址
      searchUrl(this.sn).then((res) => {
        this.baseUrl =
          'http://' + res.data.domain + '/api/relay-controller/' + this.index

        //调用控制地址，下发控制密令
        changeControl(this.baseUrl, this.state, this.sn).then((res) => {
          console.log('发送成功')
        })
      })
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/monitor/environment/MonitorOfDoctor.vue